const faqs = [
    {
        id: 1, 
        heading: 'What are the emergency procedures?',
        content: 'Learn about the step-by-step emergency procedures to follow during fire incidents. Be prepared and stay safe by understanding the recommended actions.',
    },
    {
        id: 2,
        heading: 'How is firefighting equipment maintained?',
        content: 'Explore details about the maintenance practices ensuring our firefighting equipment remains in optimal condition, ready for immediate use when needed.',
    },
    {
        id: 3,
        heading: 'What community fire safety initiatives do you have?',
        content: 'Discover our initiatives aimed at educating and engaging the community in fire safety practices. Learn how you can actively participate and contribute to a safer neighborhood.',
    },
    {
        id: 4,
        heading: 'How can I report a fire incident?',
        content: 'Understand the process for reporting fire incidents. Whether through our online reporting system or direct contact, we ensure a swift response to every reported incident.',
    },
    {
        id: 5,
        heading: 'Do you provide fire prevention tips?',
        content: 'Access valuable tips and recommendations for preventing fire hazards. Learn how to safeguard your home and community from potential fire risks.',
    },
];

export default faqs;